import cn from 'classnames';
import { tLevel } from 'common/modules/ReactShared';
import { t } from 'i18n';
import { FC, useEffect, useRef } from 'react';
import { availableLevels, levelsData } from '../../../levelsData';
import { ILanguageLevel } from './model';
import { SCell, SGrid, SImg, SSubtitle, STitle } from './styles';

export const LanguageLevel: FC<ILanguageLevel> = ({ pickedLevel, pick }) => {
  const firstItemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (firstItemRef.current) {
      firstItemRef.current.focus();
    }
  }, [firstItemRef]);

  return (
    <SGrid>
      {availableLevels.map((level: tLevel, idx) => {
        const itemLevel = levelsData.get(level);
        const onPick = () => pick(`${itemLevel?.value}`);
        const isPicked = pickedLevel === itemLevel?.value;

        return (
          <SCell
            key={level}
            className={cn({ isPicked })}
            ref={idx === 0 ? firstItemRef : null}
            tabIndex={0}
            onClick={onPick}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onPick();
              }
            }}
          >
            <SImg
              className={cn({ isPicked })}
              src={!isPicked ? itemLevel?.icon : itemLevel?.colorIcon}
            />
            <STitle>{itemLevel?.levelShortName}</STitle>
            {/* @tolgee-ignore */}
            <SSubtitle>{t(`${itemLevel?.nameShortLocaleStr}`)}</SSubtitle>
          </SCell>
        );
      })}
    </SGrid>
  );
};
